import { FunctionalComponent, h } from 'preact';

export interface LinkProps {
	href: string;
	text: string;
	type: 'internal' | 'external';
}
interface ServiceCardLinkProps extends LinkProps {
	highlighted?: boolean;
}
export const ServiceCardLink: FunctionalComponent<ServiceCardLinkProps> = (props) => {
	const { href, text, type, highlighted } = props;
	return (
		<a
			href={href}
			className={`SP-Button SP-Iconized--left SP-ServiceCard__button ${highlighted ? 'SP-Button--ghostBright' : 'SP-Button--default'}`}
			target={type === 'external' ? '_blank' : undefined}
		>
			<span className="SP-Button__ripple"></span>
			<svg className={`SPi SP-Iconized SP-Button__icon ${type === 'internal' ? 'SPi-link' : 'SPi-linkNewWindow'}`} aria-hidden="true" focusable="false">
				<use href={`#SPi-${type === 'internal' ? 'link' : 'linkNewWindow'}`} />
			</svg>
			<span className="SP-Button__text SPi-Iconized__text">{text}</span>
		</a>
	);
};
